import { render, staticRenderFns } from "./CkycApproveDetails.vue?vue&type=template&id=58d18ce6&scoped=true&"
import script from "./CkycApproveDetails.vue?vue&type=script&lang=js&"
export * from "./CkycApproveDetails.vue?vue&type=script&lang=js&"
import style0 from "./CkycApproveDetails.vue?vue&type=style&index=0&id=58d18ce6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d18ce6",
  null
  
)

export default component.exports